export const API_PATH_apiAuthLogoutGet = '/services/authentication/logout';
